var map = {
	"./American Express.svg": 1128,
	"./Diners Club.svg": 1129,
	"./Discover.svg": 1130,
	"./JCB.svg": 1131,
	"./MasterCard.svg": 1132,
	"./Visa.svg": 1133,
	"./afternoon-icon.svg": 1134,
	"./arrow-left-bg.svg": 1135,
	"./arrow-right-bg.svg": 1136,
	"./building.svg": 536,
	"./connect-calendar.svg": 411,
	"./connections.svg": 537,
	"./create-shifts.svg": 408,
	"./day-icon.svg": 1137,
	"./evening-icon.svg": 1138,
	"./facebook.svg": 282,
	"./linkedin.svg": 283,
	"./list.svg": 247,
	"./logo-dark.svg": 173,
	"./logo.svg": 78,
	"./messenger.svg": 1139,
	"./night-icon.svg": 1140,
	"./quotes.svg": 412,
	"./share-calendar.svg": 409,
	"./success.svg": 538,
	"./switch-shifts.svg": 410,
	"./twitter.svg": 284,
	"./user.svg": 335,
	"./warning.svg": 539
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1127;